<style lang="scss">
.module3 {
  .slide-13 {
    background-image: url("../../../assets/module3/slide13/background-01.jpg");
    background-size: cover;
    background-position: center;
    padding-top: 30px;
    padding-left: 140px;
    height: calc(100% - 30px);

    .timmmy {
      position: absolute;
      top: 0;
      left: 0;
    }

    h1 {
      color: #c5d43b;
      font-size: 100px;
      transform: rotate(-3deg);
      span {
        &:nth-child(1) {
          transform: translateX(-30px);
        }
        &:nth-child(2) {
          transform: translate(30px, -20px);
          margin-left: 0;
        }
      }
    }

    p {
      color: #ffffff;
      margin-top: 50px;
      max-width: 775px;
    }

    .heading2 {
      color: #ffffff;
      padding-top: 50px;
      font-size: 70px;
    }

    .heading3 {
      margin-left: 50px;
    }

    .heading4 {
      margin-left: 100px;
    }

    .heading5 {
      font-size: 80px;
      transform: rotate(-5deg);
      margin-top: 50px;
    }

    .number {
      color: #e30613;
    }

    .heading-button {
      margin-top: 550px;
      margin-left: 280px;
      width: 225px;
      flex-shrink: 0;
      img {
        transform: scale(1.6);
        padding-top: 30px;
      }
    }
    .block-text {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
    }

    .right {
      position: absolute;
      width: 50%;
      right: 0;
      top: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      & > div {
        flex: 1;
        display: flex;
        align-items: center;
        .desc {
          max-width: 200px;
          font-family: "Kookycat-FASTcaps";
          font-size: 25px;
          color: white;
        }
        .bt {
          font-size: 3em;
          display: block;
          line-height: 1;
          margin-top: 15px;
        }
        .c {
          color: #e30613;
        }
        &:first-of-type .desc {
          padding-left: 250px;
        }
        &:nth-of-type(2) .desc {
          padding-left: 420px;
        }
        &:last-of-type .desc {
          padding-left: 270px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="slide-13">
    <transition name="fadeRight" appear>
      <img
        class="chars delay-5"
        v-show="slideIndex == 12"
        src="@/assets/module3/slide13/image-01.png"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        class="chars delay-4"
        v-show="slideIndex == 12"
        src="@/assets/module3/slide13/112-01.png"
      />
    </transition>
    <transition name="fadeLeft" appear>
      <div v-show="slideIndex == 12">
        <div class="heading1">
          <h1 v-html="$t('module3.slide13.heading1')"></h1>
        </div>
      </div>
    </transition>
    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 12" class="delay-2">
        <p>{{ $t("module3.slide13.copy1") }}</p>
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 12" class="delay-3">
        <p>{{ $t("module3.slide13.copy2") }}</p>
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <div v-show="slideIndex == 12" class="delay-4">
        <h2 class="heading2">
          {{ $t("module3.slide13.heading2") }}
          <span class="number">{{ $t("module3.slide13.number") }}</span>
        </h2>
      </div>
    </transition>

    <div class="right">
      <div>
        <div class="desc">
          IF SOMEONE’S <span class="bt">FACE</span> SUDDENLY DROOPS TO
          <span class="c">ONE</span> SIDE
        </div>
      </div>

      <div>
        <div class="desc">
          IF SOMEONE SUDDENLY <br />LOSES <br />POWER <br />IN
          <span class="c">ONE</span><span class="bt">ARM</span>
        </div>
      </div>

      <div>
        <div class="desc">
          IF <span class="c">TWO</span> INCOHERENT LIPS SUDDENLY AFFECT THEIR
          <span class="bt">SPEECH</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
